if (!customElements.get('product-quick-buy')) {
class ProductQuickBuy extends HTMLElement {
  constructor() {
    super();

    this.wrapper = this.querySelector(".product-quick-buy-wrapper");
    this.overlayEle = this.querySelector(".product-quick-buy__overlay");
    this.contentEle = this.querySelector(".product-quick-buy .quicky-buy__content");
    this.closeBtn = this.querySelector(".product-quick-buy .close-btn");
    this.onBodyClick = this.handleBodyClick.bind(this);
    this.trynowTagValidation = false;

    this.initEventListener()
    
    window.addEventListener('resize', () => {
      this.setScreenHeight();
    });
  }

  initEventListener() {
    
    document.addEventListener('addToCartSuccess', (event) => {
      // document.querySelector("#FacetFiltersFormMobile").dispatchEvent(new Event("input"))
      const productHandle = this.productHandle
      if(productHandle && document.querySelector("product-card.cust-product-card[data-handle='"+productHandle+"']")){
         fetch(`/products/${productHandle}?view=cust-card`)
        .then((response) => response.text())
        .then((responseText) => {
          document.querySelector("product-card.cust-product-card[data-handle='"+productHandle+"']").parentNode.innerHTML = responseText
        })
      }
      this.close();
    })
    
   

    this.overlayEle.addEventListener("click", (e) => {
       this.close();
    })

    this.closeBtn.addEventListener("click", (e) => {
       this.close();
    })
  }

  fetchProductByTags(productHandle) {
    this.trynowTagValidation = false;
    let url = `/products/${productHandle}.js`;
    fetch(url)
    .then(response => response.json())
    .then((data) => {
      if (Array.isArray(data.tags)) {
            data.tags.forEach(tag => {
              if(tag == 'TryNowAutomated') {
                this.trynowTagValidation = true;
              } 
            });
        }
    })
  }

  // toggle code begin
    getCookieValue(cookieName) {
      let name = cookieName + "=";
      let decodedCookie = decodeURIComponent(document.cookie);
      let cookieArray = decodedCookie.split(';');
      
      for(let i = 0; i < cookieArray.length; i++) {
        let cookie = cookieArray[i].trim();
        if (cookie.indexOf(name) === 0) {
          return cookie.substring(name.length, cookie.length);
        }
      }
      return null;
    }
    
    checkCookieValue(cookieName, valueToCheck) {
      let cookieValue = this.getCookieValue(cookieName);
      return cookieValue === valueToCheck;
    }
  // toggle code end

  async fetchProduct(productHandle, variantId){
    this.productHandle = productHandle;
    this.querySelector(".quicky-buy__footer a").href = `/products/${productHandle}`
    let url = `/products/${productHandle}?view=quick-view`;
    if(variantId){
      this.querySelector(".quicky-buy__footer a").href = `/products/${productHandle}?variant=${variantId}`
      url = `/products/${productHandle}?view=quick-view&variant=${variantId}`
    }

    this.fetchProductByTags(productHandle)
    
    await fetch(url)
    .then(response => response.text())
    .then((html) => {
      const doc = new DOMParser().parseFromString(html, 'text/html');
      this.contentEle.innerHTML = "";
      this.contentEle.dataset.handle = productHandle
      this.contentEle.insertAdjacentHTML("beforeend", doc.querySelector(".product-section .prodct__details-top").outerHTML);
      this.contentEle.insertAdjacentHTML("beforeend", doc.querySelector(".product-section .product__info-wrapper").innerHTML);
      this.querySelector(".custom-floating-bar")?this.querySelector(".custom-floating-bar").remove():""
      if(this.querySelector("variant-radios")){
        this.querySelector("variant-radios").dataset.url = this.querySelector("variant-radios").dataset.url
        this.querySelector("variant-radios").dataset.updateUrl = false
        this.querySelector("variant-radios").updateCartNotification("quickview",variantId);
      }
      this.querySelectorAll(".accordion-header").forEach(header => {
        header.removeAttribute("onclick")
        header.addEventListener("click", () => {
          this.toggleAccordion(header)
        })
      })

      let trynowBlock = document.querySelector('#trynow-cta-button');
      if(window.Shopify.country != 'US' && trynowBlock) {
        trynowBlock.parentElement.classList.add('trynow-quick-buy-content');
      }

      const discount_btn = this.querySelector(".buy_with_discount_products .cust-show__discount_products-btn");
      if(discount_btn){
        this.querySelector(".buy_with_discount_products  .buy_with_discount_products__header").addEventListener("click", () => {
          discount_btn.classList.toggle('rotate-svg');
        })
      }
    })
  }

  toggleAccordion(header) {
    const content = header.nextElementSibling;
    const closeIcon = header.querySelector('.active-variant__close');
  
    if (content.style.maxHeight === "0px" || content.style.maxHeight === "") {
      content.style.maxHeight = content.scrollHeight + 'px'; // Set max-height to the scroll height
      closeIcon.classList.add('open'); // Add class to indicate open state
    } else {
      content.style.maxHeight = "0"; // Reset max-height to 0
      closeIcon.classList.remove('open'); // Remove class to indicate closed state
    }
  }
  open() {
    this.wrapper.classList.add("active")
    this.contentEle.innerHTML = "";
  }

  close() {
    this.wrapper.classList.remove("active")
    const addToCartButton = this.wrapper.querySelector('button[type="submit"]');
    if(addToCartButton){
      addToCartButton.classList.remove('visible');
    }
    
    let quickBuyFooter = this.wrapper.querySelector('.quicky-buy__footer');
    let toggleContainer = quickBuyFooter.querySelectorAll('#trynow-quick-buy-tggle-cont');
    toggleContainer.forEach(item => {
      item.remove();
    })
    quickBuyFooter.style.height = '112px';
    quickBuyFooter.style.justifyContent = 'center';
  }

  handleBodyClick(evt) {
  }


  setScreenHeight() {
  }

}

customElements.define('product-quick-buy', ProductQuickBuy);
}